export interface FileValidatorModel {
    valid: File[];
    invalid: File[];
    extensions: string[];
}

export const getBaseAllowedExts = () => {
    return ['7z', 'ace', 'doc', 'docx', 'gif', 'jpg', 'jpeg', 'ods', 'odt', 'pdf', 'png', 'rar', 'rtf', 'tif', 'txt', 'xls', 'xlsx', 'xps', 'zip', 'ppt', 'pptx']
}

export const validateFilesExt = (files: File[], allowedExtensions: string[]): FileValidatorModel => {
    const valid = [];
    const invalid = [];
    const extensions = [];

    for (let i = 0, j = files.length; i < j; i++) {

        const name = files[i]?.name;
        const matchArray = name.match(/\.([^.]+)$/);

        const ext = matchArray?.[1]?.toLocaleLowerCase() || '';

        extensions.push(ext);

        if (allowedExtensions.indexOf(ext) > -1) {
            valid.push(files[i]);
        }
        else {
            invalid.push(files[i]);
        }
    }

    return {
        valid,
        invalid,
        extensions
    };
}

/**
 *
 * @param file
 * @param maxFileSize in mb
 */
export const validateFileSize = (file: File, maxFileSize: number) => {
    const maxFileSizeInBytes = maxFileSize * 1024 * 1024;
    return file.size <= maxFileSizeInBytes;
}

export const getFileSizeLimit = (defaultFileSizeLimit: number) => {
    const limitFromConfig = process.env.VUE_APP_IMAGE_MAX_SIZE_MB;

    if (!limitFromConfig) {
        return defaultFileSizeLimit;
    }

    const limitMB = parseFloat(limitFromConfig);

    return !isNaN(limitMB) ? limitMB : defaultFileSizeLimit;
}
